module.exports = __webpack_public_path__ + "static/media/earth_logo.bcd6b63d.png";